const deps = [
  require('angular-ui-router'),
  require('ui/bk/userAssignments').name,
  require('data/model/client').name,
];

module.exports = angular
  .module('bench.app.mainapp.details.assignments', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.assignments', {
      url: '/assignments',
      views: {
        '': {
          controller($stateParams, Client) {
            this.clientId = $stateParams.clientId;
            const client = new Client(this.clientId);
            this.refetchClient = () => client.$fetch();
            return this;
          },
          controllerAs: 'vm',
          template: `
            <user-assignments
              clientId="vm.clientId"
              onClientUpdate="vm.refetchClient"
            />
          `,
        },
      },
    }),
  );
